import React from 'react';
import {observer, inject} from 'mobx-react';
import Header from './Headers';
import MetaTags from 'react-meta-tags';
import ReactGA from 'react-ga';
import Footer from '../footer';
import {Helmet} from "react-helmet";
import config from 'config'


@inject('store')
@observer
class Ourpartner extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            newpatner: [],
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.store.homeType(false);
        ReactGA.initialize('UA-128486561-1');
        ReactGA.pageview('/our_partner');
        this.ourPartner()
    }

    ourPartner = () => {
        fetch(`${config.REV_URL}/revfinpartnerwebdetail`)
            .then((response) => {
                return response.json();
            })
            .then((response) => {
                console.log('work', response)
                this.setState({
                    newpatner: response.result
                })
            }).catch((err) => {
            console.log(err)
        })
    }


    render() {
        return (
            <div>
                <Helmet>
                    <meta name="title" content="Revfin’s partnership with leading brands for Electric Vehicle loan"/>
                    <meta name="description"
                          content="Revfin’s tie-ups with leading brands to become the best lending platform for electric vehicle loan."/>
                    <meta name="keywords" content="Electric Vehicle loan"/>

                </Helmet>
                <Header/>
                <section className="pdtb-20">
                    <section className="breadcrumbs">
                        <div className="container">
                            <div className="d-flex justify-content-between align-items-center">
                                <h2>Our Partners</h2>
                                <ol>
                                    <li><a href="/">Home</a></li>
                                    <li>Our Partners</li>
                                </ol>
                            </div>
                        </div>
                    </section>
                </section>
                <section className="pdtb-20 padboth50">
                    <div className="container">
                        <div className="container">
                            <div className="section-titles">
                                <h3 className="heading_tow">Distribution Partners</h3>
                            </div>
                            {/* <div className="row">
						<div className="col-md-12">
							<h3 className="headingthod">Distribution Partners</h3>
							</div>
						</div> */}
                        </div>

                        <div className="row">
                            {
                                this.state.newpatner[0] ? (this.state.newpatner[3].map((resData, index) => (
                                    <div className="col-lg-4 col-md-4 col-xs-12 col-sm-6" key={index}>
                                        <div className="pannelgridPat">
                                            <figure>
                                                <img src={resData.image} alt=""/>
                                            </figure>
                                            <h3>{resData.name}</h3>
                                        </div>
                                    </div>
                                ))) : null

                            }
                        </div>

                        <div className="container">
                            <div className="section-titles">
                                <h3 className="heading_tow">Lending Partners</h3>
                            </div>
                            {/* <div className="row">
								<div className="col-md-12"><h3 className="headingthod">Lending Partners</h3></div>
								</div> */}
                        </div>

                        <div className="row">
                            {/* {
                                this.state.newpatner[0] ? (this.state.newpatner[1].map((resData, index) => (
                                    <div className="col-lg-4 col-md-4 col-xs-12 col-sm-6" key={index}>
                                        <div className="pannelgridPat">
                                            <figure>
                                                <img src={resData.image} alt=""/>
                                            </figure>
                                            <h3>{resData.name}</h3>
                                        </div>
                                    </div>
                                ))) : null

                            } */}
                            {
                              this.state.newpatner[0] && this.state.newpatner[1] && this.state.newpatner[1][0] ?
                                <div className="col-lg-4 col-md-4 col-xs-12 col-sm-6">
                                    <div className="pannelgridPat">
                                        <a target="_blank" href='https://www.revfincapital.com/'>
                                        <figure>
                                            <img  src={this.state.newpatner[1][0].image} alt=""/>
                                        </figure>
                                        <h3>{this.state.newpatner[1][0].name}</h3>
                                        </a>
                                    </div>
                                </div>
                             : null
                            }
                        </div>

                        <div className="container">
                            <div className="section-titles">
                                <h3 className="heading_tow">Financial Services Partners</h3>
                            </div>
                            {/* <div className="row"><div className="col-md-12"><h3 className="headingthod">Financial Services Partners</h3></div></div> */}
                        </div>

                        <div className="row">
                            {
                                this.state.newpatner[1] ? (this.state.newpatner[2].map((resData, index) => (
                                    <div className="col-lg-4 col-md-4 col-xs-12 col-sm-6" key={index}>
                                        <div className="pannelgridPat">
                                            <figure>
                                                <img src={resData.image} alt=""/>
                                            </figure>
                                            <h3>{resData.name}</h3>
                                        </div>
                                    </div>
                                ))) : null

                            }
                        </div>

                        <div className="container">
                            <div className="section-titles">
                                <h3 className="heading_tow">Memberships</h3>
                            </div>
                            {/* <div className="row"><div className="col-md-12"><h3 className="headingthod">Memberships</h3></div></div> */}
                        </div>

                        <div className="row">
                            {
                                this.state.newpatner[1] ? (this.state.newpatner[0].map((resData, index) => (
                                    <div className="col-lg-4 col-md-4 col-xs-12 col-sm-6" key={index}>
                                        <div className="pannelgridPat">
                                            <figure>
                                                <img src={resData.image} alt=""/>
                                            </figure>
                                            <h3>{resData.name}</h3>
                                        </div>
                                    </div>
                                ))) : null

                            }
                        </div>

                    </div>
                </section>
                <Footer/>
            </div>
        )
    }
}


export default Ourpartner



// WEBPACK FOOTER //
// ./src/components/partner.js